/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  selectOptions: ['מלבן', 'טרפז', 'קעור'],

  // clickable buttons with value
  buttons: [
    {
      text: 'כפתור 1',
      value: 3,
    },
    {
      text: 'כפתור 2',
      value: 3,
    },
  ],

  // input with value
  inputBoxes: [
    {
      value: 12.5,
      step: 0.5,
      min: 0,
      max: 100,
      label: 'W1',
    },
    {
      value: 75,
      step: 0.5,
      min: 0,
      max: 100,
      label: 'W2',
    },
  ],

  svgViewBox: `-4 16 108 68`,
  // svgViewBox: `${-12 - 10} ${-2 - 20} ${124 + 10 * 2} ${84 + 20 * 2}`,
};

/*****************************************
 * Examples constants and global variables
 *****************************************/

const numberOfIterations = 8; // min 2 (4->8),

const data = {
  examples: [
    // 3 examples
    {
      calcInit: 'calcInit0',
      interval: 1300,
      headerText: `לעגל מלבן`,
    },
    {
      calcInit: 'calcInit1',
      interval: 1300,
      headerText: `לעגל טרפז`,
    },
    {
      calcInit: 'calcInit2',
      interval: 1300,
      headerText: `לעגל מרובע קעור`,
    },
    // {
    //   interval: 500,
    //   headerText: `ריצה אוטומטית`,
    // }, // auto
  ],

  /*****************************************
   * Global variables
   *****************************************/

  // for each iteration we have 2x number of vertex
  exampleIdx: 0, // don't set to 0 - since it is auto
  lastExampleIdx: -1,
  rowSize: 2 ** (numberOfIterations + 1),
  colSize: numberOfIterations,
  Xcor: [],
  Ycor: [],
  coe: [
    [0.5, 0.5, 0],
    [0.125, 0.75, 0.125], // 1 - sum of 2: 0 - 1
  ],
  state: 'new', // new (new example), start (before play), in-play (play/pause)
  autoPlay: false,
};

export default data;
